// extracted by mini-css-extract-plugin
export var phone = "_47-0";